/**
 * Turns a transparent header solid after a fixed scroll distance.
 *
 * Horizon de-transparentises via an IntersectionObserver keyed on the header's
 * own visibility, which fires the moment the header is a pixel out of view.
 * This adds an explicit distance instead: past it, the header gets
 * .s18-header-solid, which the stylesheet turns into a solid background with
 * inverted (dark) text. The distance is read from data-s18-solid-offset.
 *
 * Scroll source: Horizon uses a "squeeze layout" on desktop, where .page-wrapper
 * is the scroll container and the document root has overflow:hidden. There,
 * window.scrollY is permanently 0 and window never emits scroll events, so the
 * container has to be resolved the same way assets/scroll-container.js does it.
 */
(function () {
  var CLASS = 's18-header-solid';
  var PAGE_WRAPPER = '.page-wrapper';
  var squeeze = window.matchMedia('(min-width: 990px)');
  var ticking = false;
  var listeningOn = null;

  // Mirrors getScrollContainer() in assets/scroll-container.js.
  function container() {
    if (squeeze.matches) {
      return document.querySelector(PAGE_WRAPPER) || document.scrollingElement || document.documentElement;
    }
    return document.scrollingElement || document.documentElement;
  }

  // Mirrors getScrollEventTarget() in assets/scroll-container.js.
  function eventTarget() {
    if (squeeze.matches) {
      return document.querySelector(PAGE_WRAPPER) || document;
    }
    return document;
  }

  function scrollTop() {
    var el = container();
    return (el && el.scrollTop) || 0;
  }

  function apply() {
    ticking = false;
    var y = scrollTop();

    document.querySelectorAll('[data-s18-solid-offset]').forEach(function (header) {
      var offset = parseInt(header.getAttribute('data-s18-solid-offset'), 10);
      if (!isFinite(offset) || offset < 0) offset = 100;
      header.classList.toggle(CLASS, y > offset);
    });
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(apply);
  }

  function listen() {
    var target = eventTarget();
    if (listeningOn === target) return apply();

    if (listeningOn) listeningOn.removeEventListener('scroll', onScroll);
    listeningOn = target;
    listeningOn.addEventListener('scroll', onScroll, { passive: true });
    apply();
  }

  function init() {
    listen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The scroll container swaps at the 990px breakpoint, and the header
  // re-renders in the theme editor.
  squeeze.addEventListener('change', listen);
  window.addEventListener('resize', onScroll, { passive: true });
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pageshow', apply);
})();
